import { REHYDRATE } from 'redux-persist/lib/constants';
import qs from 'qs';
import isEqual from 'lodash/isEqual';
import { getDefaultQuery, buildQuery, parseProductQueryString } from '../../utils/products.js';
import { storageAvailable } from '../../components/common/storageAvailable';
import { isMarketing } from '../../utils/pdp';

export default function requestPDP(state = {}, action) {
  const { type } = action;
  if (type === 'SET_REQUEST_PDP') {
    const { requestPDP } = action;
    return { ...state, ...requestPDP };
  }
  if (type === 'SET_RENDERING_INFO') {
    let { info = {} } = action;
    return { ...state, info };
  }
  if (type === REHYDRATE) {
    const { payload = {} } = action;
    const { requestPDP = {} } = payload;
    let { query: prevQuery = {} } = requestPDP;

    const { location = {} } = window;
    if (storageAvailable('localStorage')) {
      var storageRequest = localStorage.getItem('plpRequestMobile');
    }
    if (storageRequest) {
      try {
        storageRequest = JSON.parse(storageRequest);
      } catch (e) {}
    }
    storageRequest = storageRequest || {};

    const { pathname: locPathName = '', search = '' } = location;
    const { browserPath: reqPathName = '' } = requestPDP;
    const locPathSplits = locPathName.split('/');
    const reqPathSplits = reqPathName.split('/');
    if (locPathSplits.indexOf('p') !== -1) {
      return { ...state };
    }
    return { ...state };
  }

  return state;
}
